import { Property } from "./interfaces";

export const vrServicio: Property = { title: "Valor del Servicio", type: "integer" }